import { Menu } from '@headlessui/react';
import {
  ArrowDownTrayIcon,
  ChevronDownIcon,
} from '@heroicons/react/24/outline';

interface DownloadDropdownProps {
  onDownload: (isPPTX: boolean) => void;
}

export function DownloadDropdown({ onDownload }: DownloadDropdownProps) {
  return (
    <Menu as="div" className="relative w-full sm:w-fit">
      <Menu.Button className="inline-flex w-full items-center justify-center rounded border border-blue-500 bg-blue-500 px-5 py-2 text-sm font-medium text-white hover:bg-blue-400 focus:outline-none focus:ring-blue-500 active:bg-blue-400">
        <span className="flex items-center">
          Download Powerpoint
          <ArrowDownTrayIcon className="ml-2 h-4 w-4" />
          <ChevronDownIcon className="ml-1 h-4 w-4" />
        </span>
      </Menu.Button>
      <Menu.Items className="absolute right-0 z-20 mt-1 w-40 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
        <Menu.Item>
          {({ active }) => (
            <button
              className={`${
                active ? 'bg-gray-100' : ''
              } flex w-full items-center px-4 py-2 text-sm text-gray-700`}
              onClick={() => onDownload(true)}
            >
              Download as PPTX
            </button>
          )}
        </Menu.Item>
        <Menu.Item>
          {({ active }) => (
            <button
              className={`${
                active ? 'bg-gray-100' : ''
              } flex w-full items-center px-4 py-2 text-sm text-gray-700`}
              onClick={() => onDownload(false)}
            >
              Download as PDF
            </button>
          )}
        </Menu.Item>
      </Menu.Items>
    </Menu>
  );
}
